import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { BundleFilterInput } from '@/graphql/contracts/_generated_/contracts';
import {
  GetPaginatedFilteredBundles,
  GetPaginatedFilteredBundlesVariables,
} from '@/graphql/contracts/_generated_/getPaginatedFilteredBundles.query';
import GetPaginatedFilteredBundlesQuery from '@/graphql/contracts/getPaginatedFilteredBundles.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';

export type PaginatedFilteredBundles = PaginatedFilteredGridData<BundleFilterInput>;

export default function useGetBundles() {
  const [_getBundles, getBundlesLoading] = useLazyQuery<
  GetPaginatedFilteredBundles,
  GetPaginatedFilteredBundlesVariables
  >(GetPaginatedFilteredBundlesQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'no-cache',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getBundles = async (params: PaginatedFilteredBundles) => {
    const response = await _getBundles({
      variables: {
        ...params,
      } as GetPaginatedFilteredBundlesVariables,
    });
    return response.data?.paginatedFilteredBundles;
  };

  return {
    getBundles,
    getBundlesLoading,
  };
}
